<template>
  <div>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{ empresa.nombrec }}
            <small class="title is-5"
              >{{ empresa.nit | textnumber()
              }}{{ empresa.nit | dverif() }}</small
            >
          </h1>
          <h2 class="subtitle">{{ empresa.nombre }}</h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="field is-grouped is-grouped-multiline">
          <div class="control">
            <div class="select">
              <select name="country" v-model="data.comprobante">
                <option
                  v-for="option in comprobantes"
                  v-bind:value="option"
                  v-bind:key="option._id"
                >
                  {{ option.codigo }} {{ option.nombre }}
                </option>
              </select>
            </div>
          </div>
          <div class="control">
            <div class="select">
              <select name="country" v-model="data.mes">
                <option
                  v-for="(option, key) in meses"
                  v-bind:value="option"
                  v-bind:key="key"
                >
                  {{ option.codigo }}
                </option>
              </select>
            </div>
          </div>
          <p class="control">
            <input
              class="input"
              type="number"
              placeholder="Documento"
              v-model="data.documento"
            />
          </p>
          <p class="control">
            <button class="button is-link" @click="buscarDocumento">
              <span class="icon is-medium">
                <i class="material-icons">search</i> </span
              >&nbsp; Buscar
            </button>
          </p>
          <p class="control">
            <button class="button is-light" @click="imprimir">
              <span class="icon is-medium">
                <i class="material-icons">print</i> </span
              >&nbsp; Imprimir
            </button>
          </p>
          <p
            class="control"
            v-show="
              data.comprobante && data.comprobante.estructura === 'factura'
            "
          >
            <button class="button is-info" @click="downpdf">
              <span class="icon is-medium">
                <i class="material-icons">description</i> </span
              >&nbsp; PDF
            </button>
          </p>
        </div>
        <div class="notification" v-show="documentos.length > 0">
          <span v-if="data.comprobante">{{ data.comprobante.codigo }}</span>
          <span v-if="data.comprobante">{{ data.comprobante.nombre }}</span>
          periodo <span v-if="data.mes">{{ data.mes.codigo | periodo() }}</span
          >, documentos generados
          <strong>{{ documentos.length }}</strong>
          del {{ documentos[0] | number(0) }} al
          {{ documentos[documentos.length - 1] | number(0) }}
        </div>
        <div v-if="registros.length > 0">
          <y-printcomercial
            v-if="
              registros[0].valor &&
              data.comprobante.esfactura == false &&
              data.comprobante.estructura === 'comercial'
            "
            id="printable"
            :data="data"
            :total="total"
            :registros="registros"
          ></y-printcomercial>
          <y-printcomercialfactura
            v-if="
              registros[0].valor &&
              data.comprobante.esfactura &&
              data.comprobante.estructura === 'comercial'
            "
            id="printable"
            :data="data"
            :total="total"
            :registros="registros"
            :iva="iva"
            :cliente="cliente"
            :subtotal="subtotal"
            :vencimiento="vencimiento"
          ></y-printcomercialfactura>
          <y-printfrapvta
            v-if="
              dataprint.registros[0].valor &&
              data.comprobante.estructura === 'factura' &&
              usermongo.data.companys[this.empresa._id].preferences
                .impresora === '0'
            "
            id="printable"
            :dataprint="dataprint"
          ></y-printfrapvta>
          <y-printfrapvtastrip
            v-if="
              dataprint.registros[0].valor &&
              data.comprobante.estructura === 'factura' &&
              usermongo.data.companys[this.empresa._id].preferences
                .impresora === '1'
            "
            id="printable"
            :dataprint="dataprint"
          ></y-printfrapvtastrip>
          <y-printfrapvtastrip80
            v-if="
              dataprint.registros[0].valor &&
              data.comprobante.estructura === 'factura' &&
              usermongo.data.companys[this.empresa._id].preferences
                .impresora === '2'
            "
            id="printable"
            :dataprint="dataprint"
          ></y-printfrapvtastrip80>
          <y-printinventario
            v-if="
              registros[0].valor && data.comprobante.estructura === 'inventario'
            "
            id="printable"
            :data="data"
            :registros="registros"
          ></y-printinventario>
          <y-printcontable
            v-if="
              registros[0].valor && data.comprobante.estructura === 'contable'
            "
            id="printable"
            :data="data"
            :registros="registros"
          ></y-printcontable>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import apiServicesDos from "@/services/yungol-servicesdos";
import functions from "@/helpers/functions";
import yPrintcomercial from "@/components/prints/Printcomercial.vue";
import yPrintcomercialfactura from "@/components/prints/Printcomercialfactura.vue";
import yPrintfrapvta from "@/components/prints/Frapvta.vue";
import yPrintfrapvtastrip from "@/components/prints/Frapvtastrip.vue";
import yPrintfrapvtastrip80 from "@/components/prints/Frapvtastrip80.vue";
import yPrintinventario from "@/components/prints/Printinventario.vue";
import yPrintcontable from "@/components/prints/Printcontable.vue";

function getSum1(t, k, v, arr) {
  t.totalbruto =
    t.totalbruto + functions.dosDecimales(k.vlrUnitario * k.cantidad);
  t.descuento =
    t.descuento +
    functions.dosDecimales((k.vlrUnitario * k.cantidad * k.descuento) / 100);
  t.subtotal = t.subtotal + functions.dosDecimales(k.valor);
  t.iva =
    t.iva + functions.dosDecimales((k.valor * k.datosFactura.impuesto) / 100);
  t.total =
    t.total +
    k.valor +
    functions.dosDecimales((k.valor * k.datosFactura.impuesto) / 100);
  return t;
}

function getSum(t, k, v) {
  let debito = 0;
  let credito = 0;
  if (parseInt(k.tipo) === 1) {
    debito = k.valor;
    credito = 0;
  } else {
    debito = 0;
    credito = k.valor;
  }
  t.debito = parseInt(t.debito) + parseInt(debito);
  t.credito = parseInt(t.credito) + parseInt(credito);
  return t;
}
function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}

export default {
  data() {
    return {
      usermongo: null,
      comprobantes: [],
      meses: [],
      data: {
        comprobante: null,
        mes: null,
        documento: null,
      },
      documentos: [],
      registros: [],
      total: 0,
      vencimiento: null,
      iva: 0,
      subtotal: 0,
      cliente: null,
      dataprint: {
        totales: {
          totalbruto: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          total: 0,
        },
        empresa: {
          nit: "",
          nombrec: "",
          nombre: "",
          ciudad: "",
          direccion: "",
          telefono: "",
        },
        vencimiento: "2020-07-30T05:00:00.000Z",
        incluircambio: false,
        comprobante: {
          t1: "",
          t2: "",
          titulo: "",
          nombre: "",
          prefijo: "",
          caracteres: "",
          factura: {
            resolucion: "",
            piefactura: "",
            negrita: "",
            mensajefinal: "",
          },
        },
        contrapartidas: [
          {
            nombrepers: "",
          },
        ],
        contrapartida: {
          valor: 0,
          idcuenta: {
            nombre: "",
          },
        },
        registros: [
          {
            documento: 0,
            cantidad: 0,
            descuento: 0,
            vlrUnitario: 0,
            valor: 0,
            fecha: "2020-07-30T05:00:00.000Z",
            producto: {
              codigo: "",
              descripcion: "",
            },
            datosFactura: {
              texto: "",
              impuesto: 0,
              cambio: 0,
            },
            idnit: {
              nombre: "",
              codigo: "",
              direccion: "",
              ciudad: "",
              telefono: "",
              correo: "",
              fecha: "2020-07-30T05:00:00.000Z",
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["empresa", "idtoken", "user"]),
    compperiodo() {
      if (this.data.comprobante && this.data.mes) {
        return {
          comprobante: this.data.comprobante,
          periodo: this.data.mes,
        };
      } else {
        return false;
      }
    },
  },
  methods: {
    async downpdf() {
      try {
        console.log(this.data);
        if (!this.data.mes.mes) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un mes.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.data.documento) {
          this.$store.dispatch("notify", {
            message: "Debe indicar un número de documento.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        const f = {
          mes: this.data.mes.mes,
          year: this.data.mes.year,
          comprobante: this.data.comprobante,
          documento: this.data.documento,
        };
        let result = await apiServicesDos.post(`/downfrapdf`, f, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(
          new Blob([result.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Archivo-${ahora}.pdf`); // or any other extension
        document.body.appendChild(link);
        console.log("el link es", link);
        link.click();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema descargando el PDF.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    imprimir() {
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      this.$print("printable", {
        name: `${this.data.comprobante.nombre} - ${this.data.documento} - ${this.data.mes.codigo}`,
      });
    },
    buscarDocumento() {
      this.traeRegistros(
        this,
        this.data.comprobante._id,
        this.data.documento,
        this.data.mes.codigo
      );
    },
    async traeComprobantes(_this) {
      let result;
      try {
        result = await apiServices.get(`/comprobantes`);
        _this.comprobantes = [];
        _this.comprobantes.push({
          nombre: "Comprobantes",
        });
        let d = [];
        d = functions.order(result.data, "codigo");
        d.forEach((e) => _this.comprobantes.push(e));
        _this.data.comprobante = _this.comprobantes[0];
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    async traeMeses(_this) {
      let result;
      try {
        result = await apiServices.get(`/meses`);
        _this.meses = [];
        _this.meses.push({
          codigo: "Meses",
        });
        let d = [];
        d = functions.order(result.data, "codigo");
        d.forEach((e) => _this.meses.push(e));
        _this.data.mes = _this.meses[0];
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los meses.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los meses", err);
      }
    },
    async traeDocumentos(_this, comprobanteId, periodo) {
      let result;
      try {
        result = await apiServices.get(
          `/consulta/doumentos/${comprobanteId}/${periodo}`
        );
        this.documentos = result.data.map((e) => parseInt(e._id.documento));
        this.documentos.sort((a, b) => parseInt(a) - parseInt(b));
      } catch (err) {
        console.log("ocurrio un problema cargando los documentos", err);
      }
    },
    async traeRegistros(_this, documentoId, doc, periodo) {
      let result;
      try {
        result = await apiServices.get(
          `/mdocumento/${documentoId}/${doc}/${periodo}`
        );
        if (_this.data.comprobante.estructura === "contable") {
          _this.registros = result.data.map((e) => e);
          _this.total = result.data.reduce(getSum, {
            debito: 0,
            credito: 0,
          });
        } else if (_this.data.comprobante.estructura === "factura") {
          this.dataprint.empresa = this.empresa;
          this.dataprint.comprobante = this.data.comprobante;
          _this.registros = result.data;
          this.dataprint.registros = [];
          this.dataprint.contrapartida = {};
          this.dataprint.contrapartidas = [];
          if (
            this.usermongo &&
            this.usermongo.data.companys[this.empresa._id].preferences
              .incluircambio
          ) {
            this.dataprint.incluircambio =
              this.usermongo.data.companys[
                this.empresa._id
              ].preferences.incluircambio;
          }
          result.data.forEach(function (k, v) {
            if (k.idcuenta.ingreso) {
              _this.dataprint.registros.push(k);
            } else {
              if (_this.data.comprobante.cuenta === k.idcuenta._id) {
                _this.dataprint.contrapartida = k;
              } else {
                if (_this.data.comprobante.factura.contrapartidas) {
                  _this.data.comprobante.factura.contrapartidas.forEach(
                    function (k2, v2) {
                      if (k2._id === k.idcuenta._id) {
                        k.nombrepers = k2.nombre;
                        _this.dataprint.contrapartidas.push(k);
                      }
                    }
                  );
                }
              }
            }
          });

          _this.dataprint.totales = _this.dataprint.registros.reduce(getSum1, {
            totalbruto: 0,
            descuento: 0,
            subtotal: 0,
            iva: 0,
            total: 0,
          });
          var d = new Date(_this.dataprint.registros[0].fecha);
          var d1 = parseInt(_this.dataprint.registros[0].datosFactura.fpago);
          _this.dataprint.vencimiento = sumarDias(d, d1);
        } else if (_this.data.comprobante.estructura === "inventario") {
          _this.registros = [];
          result.data.forEach(function (key) {
            _this.registros.push(key);
          });
          _this.registros = functions.order(_this.registros, "orden");
        } else {
          _this.registros = [];
          result.data.forEach(function (key) {
            if (_this.data.comprobante.cuenta === key.idcuenta._id) {
              _this.total = key;
            } else {
              _this.registros.push(key);
            }
          });
          _this.registros = functions.order(_this.registros, "orden");
          if (_this.data.comprobante.esfactura) {
            const d = new Date(_this.total.fecha);
            const d1 = parseInt(_this.data.comprobante.vencimiento);
            _this.vencimiento = sumarDias(d, d1);
            let registros = _this.registros;
            _this.registros = [];
            _this.iva = 0;
            _this.subtotal = 0;
            for (var i = 0; i < result.data.length; i++) {
              if (result.data[i].idcuenta.tercero === true) {
                _this.cliente = result.data[i].idnit;
                if (result.data[i].idnit.ciudad) {
                  let largo = result.data[i].idnit.ciudad.length;
                  _this.cliente.ciudad = result.data[i].idnit.ciudad.substr(
                    9,
                    largo - 9
                  );
                } else {
                  _this.cliente.ciudad = false;
                }
                break;
              }
            }
            let iva = [];
            registros.forEach(function (key, val) {
              if (key.idcuenta.codigo.substr(0, 2) === "24") {
                iva.push(key);
              } else {
                _this.registros.push(key);
              }
            });
            if (iva.length > 0) {
              iva.forEach(function (key) {
                if (_this.total.tipo === key.tipo) {
                  _this.iva = _this.iva - key.valor;
                } else {
                  _this.iva = _this.iva + key.valor;
                }
              });
            }
            _this.registros.forEach(function (key) {
              if (_this.total.tipo === key.tipo) {
                _this.subtotal = _this.subtotal - key.valor;
              } else {
                _this.subtotal = _this.subtotal + key.valor;
              }
            });
          }
        }
      } catch (err) {
        console.log("ocurrio un problema cargando los documentos", err);
      }
    },
  },
  async created() {
    if (this.idtoken) {
      this.traeComprobantes(this);
      this.traeMeses(this);
      const usermongo = await apiServices.get(`/myuser`);
      this.usermongo = usermongo;
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.traeComprobantes(this);
        this.traeMeses(this);
      }
    },
    compperiodo(nv, ov) {
      if (
        nv.comprobante.nombre !== "Comprobantes" &&
        nv.periodo.codigo !== "Meses"
      ) {
        this.traeDocumentos(this, nv.comprobante._id, nv.periodo.codigo);
      }
    },
  },
  components: {
    yPrintcomercial,
    yPrintcomercialfactura,
    yPrintfrapvta,
    yPrintfrapvtastrip,
    yPrintfrapvtastrip80,
    yPrintinventario,
    yPrintcontable,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/prints/Imprimir.vue